import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getPromoCodeById } from '../../utils/api/promoCode';

function ViewPromoCodeModal({ id, show, onClose }) {
  const [promoCode, setPromoCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id || !show) return;

    setLoading(true);
    getPromoCodeById(id)
      .then((res) => {
        setPromoCode(res?.data || null);
      })
      .catch((e) => {
        console.error('Error fetching promo code:', e);
        setPromoCode(null);
      })
      .finally(() => setLoading(false));
  }, [id, show]);

  if (!show) return null;

  return (
    <motion.div
      className="modal fade show"
      tabIndex="-1"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(4px)',
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
          <div className="modal-header">
            <h6 className="modal-title">Promo Code Details</h6>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {loading ? (
               <div className="text-center  flex gap-10">
                  <div className="shimmer shimmer-text" style={{ width: '120px', height: '2.5rem', margin: 'auto' }}></div>
                  <div className="shimmer shimmer-text" style={{ width: '120px', height: '2.5rem', margin: 'auto' }}></div>
                  <div className="shimmer shimmer-text" style={{ width: '120px', height: '2.5rem', margin: 'auto' }}></div>
                  <div className="shimmer shimmer-text" style={{ width: '120px', height: '2.5rem', margin: 'auto' }}></div>
                  <div className="shimmer shimmer-text" style={{ width: '120px', height: '2.5rem', margin: 'auto' }}></div>

                </div>
            ) : promoCode ? (
              <div className="row g-3">

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Code</label>
                  <div className="form-control">{promoCode.code}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Type</label>
                  <div className="form-control text-capitalize">{promoCode.type}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Value</label>
                  <div className="form-control">{promoCode.value}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Min Purchase Minutes</label>
                  <div className="form-control">{promoCode.minPurchaseMinutes}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Usage Limit</label>
                  <div className="form-control">{promoCode.usageLimit}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Current Usage</label>
                  <div className="form-control">{promoCode.currentUsage}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Expires At</label>
                  <div className="form-control">
                    {promoCode.expiresAt
                      ? new Date(promoCode.expiresAt).toLocaleString('en-IN')
                      : 'No expiry'}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Status</label>
                  <div className="form-control">
                    <span className={`badge ${promoCode.isActive ? 'bg-success' : 'bg-danger'}`}>
                      {promoCode.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Created By (Admin ID)</label>
                  <div className="form-control">{promoCode.createdByAdminId}</div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Created At</label>
                  <div className="form-control">
                    {new Date(promoCode.createdAt).toLocaleString('en-IN')}
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Updated At</label>
                  <div className="form-control">
                    {new Date(promoCode.updatedAt).toLocaleString('en-IN')}
                  </div>
                </div>

              </div>
            ) : (
              <div className="text-danger text-center py-4">
                Promo code not found or failed to load.
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default ViewPromoCodeModal;
